import DeleteReward from './DeleteReward';
export default DeleteReward;